import { render, staticRenderFns } from "./SalesCartItemDetails.vue?vue&type=template&id=95535b92&scoped=true&lang=pug&"
import script from "./SalesCartItemDetails.vue?vue&type=script&lang=js&"
export * from "./SalesCartItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesCartItemDetails.vue?vue&type=style&index=0&id=95535b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95535b92",
  null
  
)

component.options.__file = "SalesCartItemDetails.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VFlex,
  VLayout,
  VTooltip,
})
